import { render, staticRenderFns } from "./detailReport.vue?vue&type=template&id=30758e57&"
import script from "./detailReport.vue?vue&type=script&lang=js&"
export * from "./detailReport.vue?vue&type=script&lang=js&"
import style0 from "./detailReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports